import { Button, Result } from "antd";
import DashboardLayout from "layout/DashboardLayout";
import React from "react";
import { TbAlertCircleFilled } from "react-icons/tb";
import { getErrorMessage } from "utils/functions";

const ErrorComponent = ({ error }: { error: any }) => {
  return (
    <DashboardLayout>
      <div className="flex items-center justify-center p-5 max-w-[700px] mx-auto">
        <Result
          icon={<TbAlertCircleFilled size={72} className={`mx-auto text-red-500`} />}
          status={"error"}
          // title={query.error.response?.statusText}
          subTitle={getErrorMessage(error)}
          //   extra={<Button href="/dashboard">Go Dashboard</Button>}
        />
      </div>
    </DashboardLayout>
  );
};

export default ErrorComponent;
